function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "275.6 13.2 21.9 13.2 35.5 0 262.9 0",
  fill: "#289C46"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "181.9 13.2 115.5 13.2 120.9 0 176.6 0",
  fill: "#EDEBA0"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "125.1 13.2 120.9 13.2 126.2 0 130.5 0",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "176.6 13.2 172.3 13.2 167 0 171.3 0",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 21.9,
  y: 13,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 115.5,
  y: 13,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 120.9,
  y: 13,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 172.3,
  y: 13,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 21.9,
  y: 41.5,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 24.6,
  y: 48,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 118.2,
  y: 48,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 123.5,
  y: 48,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 175,
  y: 48,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 24.6,
  y: 76.4,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 16.6,
  y: 82.9,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 110.2,
  y: 82.9,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 115.5,
  y: 82.9,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 167,
  y: 82.9,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 16.6,
  y: 111.3,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 27.2,
  y: 117.8,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 120.9,
  y: 117.8,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 126.2,
  y: 117.8,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 177.6,
  y: 117.8,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 27.2,
  y: 146.3,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m68.4 99.7c15-0.2 27.2 3.4 27.3 8l0.5 41.2c0 1.5-1.3 2.9-3.6 4.2-4.7 2.5-13.4 4.3-23.5 4.4s-18.9-1.5-23.6-3.9c-2.3-1.2-3.7-2.6-3.7-4.1l-0.5-41.2c0-4.6 12.1-8.4 27.1-8.6z",
  fill: "#FADD75"
});

var _ref27 = /*#__PURE__*/React.createElement("g", {
  fill: "#FCAB1E"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.6 117.7c10.1-0.1 19.1-1.8 24.2-4.6 3.7-2 4.4-4.1 4.4-5.5-0.1-6.4-14.6-9.6-28.9-9.5-14.3 0.2-28.7 3.7-28.6 10.1 0 1.4 0.8 3.6 4.5 5.4 5.3 2.7 14.4 4.2 24.4 4.1zm-0.2-16.5c15.7-0.2 25.7 3.7 25.7 6.4 0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7 0-2.7 10-6.8 25.6-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.9 142.5c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.4 14.6 9.6 28.9 9.5zm25.5-13.7v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4s19.1-1.8 24.2-4.6c0.5-0.2 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m69 150.7c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.5 14.6 9.7 28.9 9.5zm25.5-13.6v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.3 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.8 134.2c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.3 2.7 14.3 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.3 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m69.1 158.9c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.2 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.7 126c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.3 2.7 14.4 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.3 1-0.6 1.4-0.8z"
}));

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m70.5 107.3c-0.3-0.1-0.6-0.1-1-0.2-2.4-0.5-3.6-0.9-3.6-1.2 0-0.2 0.2-0.4 0.6-0.5s1-0.2 1.7-0.2c1 0 1.7 0.1 2.1 0.2 0.5 0.2 0.7 0.4 0.7 0.8v0.1l4.9-0.1v-0.2c0-0.8-0.6-1.4-1.8-1.8-0.8-0.3-1.9-0.4-3.2-0.5v-1l-4.8 0.1v1c-1.3 0.1-2.4 0.3-3.2 0.5-1.3 0.4-2 0.9-2 1.6 0 0.5 0.4 0.9 1.2 1.3s2.6 0.8 5.5 1.4c0.2 0 0.4 0.1 0.6 0.1 1.9 0.4 2.8 0.7 2.8 1 0 0.2-0.2 0.4-0.7 0.6-0.4 0.1-1.1 0.2-1.8 0.2-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1l-5 0.1v0.2 0.1c0 0.8 0.6 1.5 1.9 1.8 0.8 0.3 2 0.4 3.5 0.5v1l4.8-0.1v-1c1.4-0.1 2.5-0.3 3.4-0.5 1.4-0.4 2-0.9 2-1.6-0.1-0.7-2-1.5-5.9-2.3z",
  fill: "#fff"
});

var _ref29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "f",
  d: "m92.9 113.2c-5.1 2.7-14.2 4.4-24.2 4.6-10.1 0.1-19.2-1.4-24.3-4-3.7-1.9-4.5-4-4.5-5.5v0l0.5 41.2c0.1 6.4 14.6 9.6 28.9 9.5 14.3-0.2 28.7-3.7 28.6-10.1l-0.5-41.2c-0.1 1.4-0.9 3.5-4.5 5.5z"
}));

var _ref30 = /*#__PURE__*/React.createElement("clipPath", {
  id: "e"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f"
}));

var _ref31 = /*#__PURE__*/React.createElement("polygon", {
  points: "34.3 163.5 65.8 164 65.2 103.7 33.7 103.2",
  clipPath: "url(#e)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "m28.5 65.8c15-0.2 27.2 3.4 27.3 8l0.9 82.4c0.1 4.6-12.1 8.4-27.1 8.6s-27.2-3.4-27.3-8l-0.9-82.4c0-4.6 12.1-8.5 27.1-8.6z",
  fill: "#FADD75"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "m29 108.2c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.5 14.6 9.7 28.9 9.5zm25.5-13.6v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.3 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "m29.1 116.5c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.4 14.6 9.6 28.9 9.5zm25.5-13.7v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.2 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "m28.9 100c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.3 1-0.6 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "m29.3 133c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.4 14.6 9.6 28.9 9.5zm25.5-13.7v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.2 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "m29.4 141.2c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.4 14.6 9.7 28.9 9.5zm25.5-13.6v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.3 0.9-0.6 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "m29.2 124.7c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.3 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "m29.5 157.7c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.4 14.6 9.6 28.9 9.5zm25.5-13.7v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.2 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "m29.6 165.9c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.5 14.6 9.7 28.9 9.5zm25.5-13.6v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.3 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "m29.4 149.4c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.3 2.7 14.4 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4s19.1-1.8 24.2-4.6c0.6-0.2 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "m28.8 91.7c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.3 2.7 14.3 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.2 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "m28.7 83.5c10.1-0.1 19.1-1.8 24.2-4.6 3.7-2 4.4-4.1 4.4-5.5-0.1-6.4-14.6-9.6-28.9-9.5-14.3 0.2-28.7 3.7-28.6 10.1 0 1.4 0.8 3.6 4.5 5.4 5.3 2.7 14.4 4.2 24.4 4.1zm-0.2-16.5c15.7-0.2 25.7 3.7 25.7 6.4 0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7 0-2.7 10-6.8 25.6-7z",
  fill: "#FCAB1E"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "m30.6 73.1c-0.3-0.1-0.6-0.1-1-0.2-2.4-0.5-3.6-0.9-3.6-1.2 0-0.2 0.2-0.4 0.6-0.5s1-0.2 1.7-0.2c1 0 1.7 0.1 2.1 0.2 0.5 0.2 0.7 0.4 0.7 0.8v0.1l4.9-0.1v-0.2c0-0.8-0.6-1.4-1.8-1.8-0.8-0.3-1.9-0.4-3.2-0.5v-1l-4.8 0.1v1c-1.3 0.1-2.4 0.3-3.2 0.5-1.3 0.4-2 0.9-2 1.6 0 0.5 0.4 0.9 1.2 1.3s2.6 0.8 5.5 1.4c0.2 0 0.4 0.1 0.6 0.1 1.9 0.4 2.8 0.7 2.8 1 0 0.2-0.2 0.4-0.7 0.6-0.4 0.1-1.1 0.2-1.8 0.2-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1l-5 0.1v0.2 0.1c0 0.8 0.6 1.5 1.9 1.8 0.9 0.3 2 0.4 3.5 0.5v1l4.8-0.1v-1c1.4-0.1 2.5-0.3 3.4-0.5 1.4-0.4 2-0.9 2-1.6-0.1-0.7-2-1.5-5.9-2.3z",
  fill: "#fff"
});

var _ref45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "d",
  d: "m91.1 154.8c-5.2-2.5-14.3-3.9-24.3-3.7-10.1 0.2-19.1 2-24.1 4.9-3.7 2-4.4 4.1-4.3 5.6v0l-0.2-8.2-0.2-8.2-0.2-8.2-0.2-8.2-0.2-8.2-0.2-8.2-0.2-8.2-0.3-8.2-0.2-8.2-0.2-8.2c-0.2-6.4 14.3-10.2 28.5-10.4 14.3-0.4 28.8 2.8 29 9.2l0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2c-0.2-1.7-1-3.8-4.7-5.6z"
}));

var _ref46 = /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d"
}));

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011024 .011024 .9999 -1.2914 .5316)",
  x: 32.5,
  y: 66.9,
  width: 30.2,
  height: 101.1,
  clipPath: "url(#c)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "m80.1 142.5c15-0.2 27.2 3.4 27.3 8l0.2 16.3c0 1.5-1.3 2.9-3.6 4.2-4.7 2.5-13.4 4.3-23.5 4.4s-18.9-1.5-23.6-3.9c-2.3-1.2-3.7-2.6-3.7-4.1l-0.2-16.3c-0.1-4.6 12.1-8.4 27.1-8.6z",
  fill: "#FADD75"
});

var _ref49 = /*#__PURE__*/React.createElement("g", {
  fill: "#FCAB1E"
}, /*#__PURE__*/React.createElement("path", {
  d: "m80.3 160.6c10.1-0.1 19.1-1.8 24.2-4.6 3.7-2 4.4-4.1 4.4-5.5-0.1-6.4-14.6-9.6-28.9-9.5-14.3 0.2-28.7 3.7-28.6 10.1 0 1.4 0.8 3.6 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm-0.2-16.5c15.7-0.2 25.7 3.7 25.7 6.4 0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7 0-2.8 10-6.8 25.6-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m80.5 177c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.3 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.2 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m80.4 168.8c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.3 1-0.5 1.4-0.8z"
}));

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "m82.2 150.1c-0.1 0-0.1 0 0 0-0.3-0.1-0.6-0.1-1-0.2-2.4-0.5-3.6-0.9-3.6-1.2 0-0.2 0.2-0.4 0.6-0.5s1-0.2 1.7-0.2c1 0 1.7 0.1 2.1 0.2 0.5 0.2 0.7 0.4 0.7 0.8v0.1l4.9-0.1v-0.2c0-0.8-0.6-1.4-1.8-1.8-0.8-0.3-1.9-0.4-3.2-0.5v-1l-4.8 0.1v1c-1.3 0.1-2.4 0.3-3.2 0.5-1.3 0.4-2 0.9-2 1.6 0 0.5 0.4 0.9 1.2 1.3s2.6 0.8 5.5 1.4c0.2 0 0.4 0.1 0.6 0.1 1.9 0.4 2.8 0.7 2.8 1 0 0.2-0.2 0.4-0.7 0.6-0.4 0.1-1.1 0.2-1.8 0.2-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1l-5 0.1v0.2s0 0.1 0 0.1c0 0.8 0.6 1.5 1.9 1.8 0.9 0.3 2 0.4 3.5 0.5v1l4.8-0.1v-1c1.4-0.1 2.5-0.3 3.4-0.5 1.4-0.4 2-0.9 2-1.6-0.1-0.7-2.1-1.5-5.9-2.3z",
  fill: "#fff"
});

var _ref51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "b",
  d: "m104.5 156c-5.1 2.7-14.2 4.4-24.2 4.6-10.1 0.1-19.2-1.4-24.3-4-3.7-1.9-4.5-4-4.5-5.5v0l0.2 16.4c0.1 6.4 14.6 9.6 28.9 9.5s28.7-3.7 28.6-10.1l-0.2-16.3c-0.1 1.4-0.9 3.5-4.5 5.4z"
}));

var _ref52 = /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b"
}));

var _ref53 = /*#__PURE__*/React.createElement("polygon", {
  points: "45.7 181.5 77.2 181.9 76.8 146.5 45.3 146",
  clipPath: "url(#a)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var SvgConsumo3 = function SvgConsumo3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 280.8 177",
    viewBox: "0 0 280.8 177",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConsumo3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/consumo3.3ad33dd6.svg";
export { ForwardRef as ReactComponent };